import type { Theming } from "@fanduel/formation-shared-types";

export const iconButtonSizes = {
  small: {
    width: "32px",
    height: "32px",
    padding: "6px"
  },
  regular: {
    width: "44px",
    height: "44px",
    padding: "12px"
  }
};

export const getThemeColor = (theme: Theming.ThemeShape, token: string) =>
  theme.colors?.[token as Theming.ColorKeys] ?? token;
